import { InjectionKey } from 'vue';
import TraceTail from '@tracetail/js';
import { TraceTailOptions } from './types';

export const TRACETAIL_KEY: InjectionKey<{
  client: TraceTail;
  options: TraceTailOptions;
}> = Symbol('tracetail');